export type TaskResponse = {
    task_id: string;
    status: string;
    result: string;
  };
  
export interface TaskStatuses {
      [activateStudyId: number]: PollingStudyFlagsAndTask;
  }

export interface TaskPollingStatuses {
    [activateStudyId: number]: "";
}
  
export interface StudyFlags {
    active: boolean;
    created: boolean;
    properties: boolean;
    questions: boolean;
    demographics: boolean;
    intro_consent: boolean;
    base: boolean;
    constant: boolean;
  }

export interface Task {
    name: string;
    study_object_key: keyof StudyFlags; 
  }
  
  //Mapping the task name to the object key from study response
export  const TASKS: Task[] = [
    {name: 'Create Survey', study_object_key: "created"},
    {name: 'Import Survey Properties', study_object_key: "properties"},
    {name: 'Import Intro and Consent', study_object_key: "intro_consent"},
    {name: 'Import Demographics', study_object_key: "demographics"},
    {name: 'Import Questions Groups', study_object_key: "questions"},
    {name: 'Import Base Groups', study_object_key: "base"},
    {name: 'Import Constants', study_object_key: "constant"},
    {name: 'Activate Survey', study_object_key: "active"}
  ];
  
 export interface PollingStudyFlagsAndTask {
      active: boolean;
      created: boolean;
      properties: boolean;
      questions: boolean;
      demographics: boolean;
      intro_consent: boolean;
      base: boolean;
      constant: boolean;
      task: TaskResponse | null;
  }